import React from "react";
import PropTypes from "prop-types";
import { components } from "react-select";

import SvgIcon from "../Icon/SvgIcon.jsx";

/**
 * Переопрелделить визуал элемента для кнопки открытия выпадающего списка
 *
 * @param {Object} props
 * @return {JSX.Element}
 */
export const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <SvgIcon name="chevronLeft" size="lg" color="#AAABAD" />
    </components.DropdownIndicator>
  );
};

DropdownIndicator.propTypes = {
  props: PropTypes.object,
};
